import http from "./http";

// 查询工作台数据
const getWorkBenchBasicDataApi = (reqParam) => {
	return new Promise((resolve, reject) => {
		http.get("/common-web/workBench/getWorkBenchBasicData", reqParam, false)
			.then((result) => {
				resolve(result);
			})
			.catch((error) => {
				reject(error);
			});
	});
};
// 待审核列表
const getWorkBenchAuditListApi = (reqParam) => {
	return new Promise((resolve, reject) => {
		http.get("/common-web/workBench/getWorkBenchAuditList", reqParam, false)
			.then((result) => {
				resolve(result);
			})
			.catch((error) => {
				reject(error);
			});
	});
};

// 待审核列表
const getWorkBenchProcessingListApi = (reqParam) => {
	return new Promise((resolve, reject) => {
		http.get("/common-web/workBench/getWorkBenchProcessingList", reqParam, false)
			.then((result) => {
				resolve(result);
			})
			.catch((error) => {
				reject(error);
			});
	});
};

//待审核列表 导出
const exportWorkBenchAuditListApi = (reqParam) => {
	return new Promise((resolve, reject) => {
		http.get(
			"/common-web/workBench/exportWorkBenchAuditList",
			reqParam,
			false
		)
			.then((result) => {
				resolve(result);
			})
			.catch((error) => {
				reject(error);
			});
	});
};
// 审批历史
const getWorkBenchAuditHistoryListApi = (reqParam) => {
	return new Promise((resolve, reject) => {
		http.get(
			"/common-web/workBench/getWorkBenchAuditHistoryList",
			reqParam,
			false
		)
			.then((result) => {
				resolve(result);
			})
			.catch((error) => {
				reject(error);
			});
	});
};
//审批历史 导出
const exportWorkBenchAuditHistoryListApi = (reqParam) => {
	return new Promise((resolve, reject) => {
		http.get(
			"/common-web/workBench/exportWorkBenchAuditHistoryList",
			reqParam,
			false
		)
			.then((result) => {
				resolve(result);
			})
			.catch((error) => {
				reject(error);
			});
	});
};

//已提交待审批 导出
const exportWorkBenchProcessingListApi = (reqParam) => {
	return new Promise((resolve, reject) => {
		http.get(
			"/common-web/workBench/exportWorkBenchProcessingList",
			reqParam,
			false
		)
			.then((result) => {
				resolve(result);
			})
			.catch((error) => {
				reject(error);
			});
	});
};

//审批历史 导出
const backApproveProcessApi = (reqParam) => {
	return new Promise((resolve, reject) => {
		http.post("/common-web/approve/backApproveProcess", reqParam, false)
			.then((result) => {
				resolve(result);
			})
			.catch((error) => {
				reject(error);
			});
	});
};

// 已驳回列表
const getWorkBenchRejectListApi = (reqParam) => {
	return new Promise((resolve, reject) => {
		http.get("/common-web/workBench/getWorkBenchRejectList", reqParam, false)
			.then((result) => {
				resolve(result);
			})
			.catch((error) => {
				reject(error);
			});
	});
};
//已驳回列表 导出
const exportWorkBenchRejectListApi = (reqParam) => {
	return new Promise((resolve, reject) => {
		http.get(
			"/common-web/workBench/exportWorkBenchRejectList",
			reqParam,
			false
		)
			.then((result) => {
				resolve(result);
			})
			.catch((error) => {
				reject(error);
			});
	});
};

//获取项目部列表
const getProjectDeptListApi = () => {
	return new Promise((resolve, reject) => {
		http.get("/contract-web/project/queryAllProjectDept", {}, true)
			.then((result) => {
				resolve(result);
			})
			.catch((error) => {
				reject(error);
			});
	});
};

//获取项目列表
const getProjectListApi = (params) => {
	return new Promise((resolve, reject) => {
		http.get("/contract-web/project/queryProjectListByDeptId", params, true)
			.then((result) => {
				resolve(result);
			})
			.catch((error) => {
				reject(error);
			});
	});
};

//根据组织查询部门列表
const getDeptListApi = (reqParam) => {
	return new Promise((resolve, reject) => {
		http.get("/appuser-web/org/dept/list", reqParam, true)
			.then((result) => {
				resolve(result);
			})
			.catch((error) => {
				reject(error);
			});
	});
};

//获取有效子部门列表
const getSubDeptListApi = (reqParam) => {
	return new Promise((resolve, reject) => {
		http.get("/appuser-web/dept/sub/list", reqParam, true)
			.then((result) => {
				resolve(result);
			})
			.catch((error) => {
				reject(error);
			});
	});
};

//批量审批
const batchSubmitApproveProcessApi = (reqParam) => {
	return new Promise((resolve, reject) => {
		http.post("/common-web/approve/batchSubmitApproveProcess", reqParam, false)
			.then((result) => {
				resolve(result);
			})
			.catch((error) => {
				reject(error);
			});
	});
};

export {
	getWorkBenchBasicDataApi,
	getWorkBenchAuditListApi,
	getWorkBenchProcessingListApi,
	getWorkBenchAuditHistoryListApi,
	exportWorkBenchAuditHistoryListApi,
	exportWorkBenchProcessingListApi,
	backApproveProcessApi,
	getProjectDeptListApi,
	getWorkBenchRejectListApi,
	exportWorkBenchRejectListApi,
	getProjectListApi,
	getDeptListApi,
	getSubDeptListApi,
	exportWorkBenchAuditListApi,
	batchSubmitApproveProcessApi
};
